module.exports = __webpack_public_path__ + "static/media/cards_lightgrey.5d2597a0.png";